import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Exercise = makeShortcode("Exercise");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Breaking While Loops`}</h1>
    <p>{`It's time to break some code! `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "hammer"
      }}>{`🔨`}</span></p>
    <h2>{`Steps to Complete`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run the first while loop and see what happens!`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Try changing the `}<inlineCode parentName="p">{`break`}</inlineCode>{` keyword to `}<inlineCode parentName="p">{`continue`}</inlineCode>{`. What happens now?`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Try changing the order of the lines in the loop. What happens if you place the print statement
after the conditional? After the counter increment? Play around with the different ways you can
break loops in Python!`}</p>
      </li>
    </ol>
    <Exercise contentSrc="@makeschool2/T7-BreakingWhileLoops" title="Breaking While Loops" mdxType="Exercise" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      